export const AKKURAT_PRO = 'Akkurat Pro';
export const ROBOTO = `'Roboto'`;
